import * as React from 'react';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import { SubscriptionFilter, FiltreSubState, FieldSort } from './internalComponents/SubscriptionFilter';
import { ListSubscription } from './internalComponents/ListSubscription';

interface Props {

}

interface State {
    subFieldSort: FieldSort;
    subTypeFilter: FiltreSubState;
}

/**
 * Ce composant permet d'afficher la page des subscriptions
 */
export class SubscriptionManagmentPage extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {
            subFieldSort: FieldSort.PSEUDO_ASC,
            subTypeFilter: FiltreSubState.A_VALIDER,
        };
    }

    render() {
        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.ADMIN,
                ]}
            >
                <div>
                    <SubscriptionFilter 
                        subFieldSort={this.state.subFieldSort}
                        subTypeFilter={this.state.subTypeFilter}
                        setFieldSort={
                            (f: FieldSort) => {
                                this.setState({subFieldSort: f});
                            }
                        }
                        setSubStateFilter={
                            (f: FiltreSubState) => {
                                this.setState({subTypeFilter: f});
                            }
                        }
                    />
                    <ListSubscription 
                        subFieldSort={this.state.subFieldSort}
                        subTypeFilter={this.state.subTypeFilter}
                    />
                </div>

            </PageChorinitia>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/SubscriptionManagmentPage/SubscriptionManagmentPage.tsx